<script setup>
import { useSlots } from 'vue'
const slots = useSlots()
</script>

<template>
  <div class="flex flex-col h-screen">
    <slot
      v-if="slots.topbar"
      name="topbar"
    />
    <div class="flex flex-1 overflow-hidden">
      <aside class="md:h-full md:block overflow-y-auto">
        <slot
          v-if="slots.sidebar"
          name="sidebar"
        />
      </aside>
      <div class="flex flex-1 bg-surface-100">
        <main class="relative flex flex-1 bg-surface-0 md:m-2 md:p-2 md:rounded-lg shadow-md">
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>
